import Skeleton from "react-loading-skeleton";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import styles from "./prepaid-last-purchase-card.module.scss";

export const PrepaidLastPurchaseCardSkeleton = () => {
	return (
		<div className={styles.row}>
			<div className={styles.cardWrapper}>
				<CardFrame>
					<div className={styles.card}>
						<span className={styles.label}>Last Purchase</span>
						<Skeleton width={110} height={28} />
					</div>
				</CardFrame>
			</div>
			<div className={styles.cardWrapper}>
				<CardFrame>
					<div className={styles.card}>
						<span className={styles.label}>Units Remaining</span>
						<Skeleton width={90} height={28} />
					</div>
				</CardFrame>
			</div>
		</div>
	);
};
